import { createSlice } from '@reduxjs/toolkit';

const initialState = { value: {} };

export const actionKeySlice = createSlice({
  name: 'actionKey',
  initialState,
  reducers: {
    setactionKey: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setactionKey } = actionKeySlice.actions;

export default actionKeySlice.reducer;
